import React from 'react';
import { withStyles, ListItemSecondaryAction } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Delete from '@material-ui/icons/Delete';
import Slide from '@material-ui/core/Slide';
import Empty from '../../components/Empty/Empty';
import Loading from '../../components/Loading/Loading';
import Api from '../../api/Api.js';
import EmailEndpoints from '../../api/EmailEndpoints';

const useStyles = {
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
};

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class SelectTemplate extends React.Component {

    state = {
        templates: [],
        loading: true
    }

    componentDidMount() {
        this.refreshData();
    }

    refreshData() {
        this.setState({ loading: true }, () => {
            Api.get(EmailEndpoints.listTemplates)
                .then(({ data }) => {
                    this.setState({ templates: data, loading: false })
                })
                .catch((e) => {
                    console.error(e);
                })
        })
    }

    render() {
        const { classes } = this.props;

        return (
            <Dialog fullScreen open={this.props.open} onClose={() => this.props.close()} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={() => this.props.close()} aria-label="Close">
                            <CloseIcon />
                        </IconButton>
                        <h4>
                            Choose your Template
                        </h4>
                    </Toolbar>
                </AppBar>
                {
                    this.state.loading ?
                        <Loading>
                            Retrieving Templates...
                        </Loading>
                        :
                        (
                            this.state.templates.length === 0 ?
                                <div style={{ textAlign: 'center', flex: 1 }}>
                                    <Empty
                                        title="No Templates"
                                        subtitle="That's odd..."
                                    />
                                    <br />
                                    <Button onClick={() => this.props.close()}>Cancel</Button>
                                </div>
                                :
                                <List>
                                    {
                                        this.state.templates.map(
                                            template =>
                                                [
                                                    <ListItem
                                                        key="listItem"
                                                        onClick={() => this.props.close(template)}
                                                        button
                                                    >
                                                        <ListItemText primary={template.name} secondary={template.letterhead} />
                                                        <ListItemSecondaryAction>
                                                            <IconButton 
                                                                aria-label="Delete" 
                                                                color="secondary"
                                                                onClick={() => 
                                                                    Api.get(EmailEndpoints.deleteTemplate, { id: template.id })
                                                                    .then(() => this.refreshData())
                                                                }
                                                            >
                                                                <Delete />
                                                            </IconButton>
                                                        </ListItemSecondaryAction>
                                                    </ListItem>,
                                                    <Divider key="divider" />
                                                ]
                                        )
                                    }
                                </List>
                        )
                }
            </Dialog>
        );
    }
}
export default withStyles(useStyles)(SelectTemplate);